export const PRINT_CONTENT_ARRANGEMENT_DELAY = 200;
